import { HOUR } from "./queryCacheTimes";
import { ZERO } from "./constants";
export const SCHOOL_API_CACHE_TIME_MS = HOUR;

export const SCHOOL_TYPE_OPTIONS = [
  { key: "Public", value: "Public", label: "Public" },
  { key: "Private", value: "Private", label: "Private" },
];

export const formatSchoolType = (schoolType) => {
  if (!schoolType) return "";
  const normalized = String(schoolType).trim().toUpperCase();
  if (normalized === "PUBLIC") return "Public";
  if (normalized === "PRIVATE") return "Private";
  return "";
};

export const UDISE_CODE_PATTERN = /^\d{11}$/;
export const UDISE_CODE_LENGTH = 11;
export const SCHOOL_CODE_PATTERN = /^SCH\d{8}$/i;
export const NON_INDIA_UDISE_CODE = "none";

export const isSchoolNameBlank = (value) => !String(value || "").trim();

export const sanitizeUdiseCode = (value) =>
  String(value || "")
    .replace(/\D/g, "")
    .slice(ZERO, UDISE_CODE_LENGTH);

export const SCHOOL_STATUS = {
  ACTIVE: 1,
  INACTIVE: 2,
};

export const SCHOOL_STATUS_LABELS = {
  [SCHOOL_STATUS.ACTIVE]: "Active",
  [SCHOOL_STATUS.INACTIVE]: "Inactive",
};
export const SCHOOL_PAGE_SIZE_OPTIONS = [10, 15, 25];
export const DEFAULT_SCHOOL_PAGE_NUMBER = 1;

export const SEARCH_SCHOOL_BY_UDISE_CODE = "udiseCode";
export const SEARCH_SCHOOL_BY_SCHOOL_CODE = "schoolCode";
export const SEARCH_SCHOOL_BY_NAME = "name";

export const SCHOOL_API_FAILURE_STATUS = "failure";
export const STATE_DISTRICT_FIELDS = ["state", "district", "stateId", "districtId"];
export const TOKEN_ENV_MAP = {
  "staging-user-token": "staging",
  "preprod-user-token": "preprod",
  "user-token": "prod",
  "dev-user-token": "staging",
};

export const SCHOOL_ACCESS_BY_ENV = {
  staging: {
    fullAccessRoleIds: [49, 67, 68],
    createOnlyRoleIds: [69, 70, 71],
  },
  preprod: {
    fullAccessRoleIds: [41, 81, 82],
    createOnlyRoleIds: [83, 84, 85],
  },
  prod: {
    fullAccessRoleIds: [38, 71, 72],
    createOnlyRoleIds: [73, 74, 75],
  },
};

export const SCHOOL_POC_ROLE_IDS_BY_ENV = {
  staging: [56],
  preprod: [66],
  prod: [76],
};

export const INDIA_COUNTRY_NAME = "india";
export const UAE_COUNTRY_ALIASES = ["united arab emirates"];
export const SELECTABLE_COUNTRY_ALIASES = [
  INDIA_COUNTRY_NAME,
  ...UAE_COUNTRY_ALIASES,
];

export const INDIA_POSTAL_CODE_LENGTH = 6;
export const INDIA_POSTAL_CODE_PATTERN = /^\d{6}$/;

export const ADDRESS_MAX_LENGTH = 200;
export const MAX_STUDENT_COUNT = 999999;
export const MAX_GRADE_COUNT_INPUT_LENGTH = 6;
export const MAX_VISIBLE_BOARD_CHIPS = 3;

export const SCHOOL_BOARD_FIELDS = [
  {
    name: "secondaryBoardIds",
    label: "Secondary Boards",
    payloadKey: "secondary_board_ids",
  },
  {
    name: "seniorSecondaryBoardIds",
    label: "Senior Secondary Boards",
    payloadKey: "senior_secondary_board_ids",
  },
];

export const MIN_POC_SEARCH_LENGTH = 3;

export const STATE_DISTRICT_DISPLAY_FIELDS = ["state", "district"];

export const VIEW_DASH = "—";

export const SEARCH_SCHOOL_LIST_FIELDS = [
  { key: "schoolCode", label: "School Code" },
  { key: "udiseCode", label: "UDISE Code" },
  { key: "address", label: "Address" },
];

export const GRADE_DISPLAY_PREFIX = "Grade ";
export const GRADE_NAME_PREFIX = "grade";

export const COPY_FEEDBACK_DURATION_MS = 2000;

export const SCHOOL_API_DEFAULT_ERROR_MESSAGE =
  "Something went wrong, please try again.";

export const SCHOOL_ID_QUERY_PARAM = "schoolId";

export const DEFAULT_SCHOOL_PAGE_SIZE = SCHOOL_PAGE_SIZE_OPTIONS[0];

export const SCHOOL_API_PATHS = {
  SEARCH: "/search-school",
  GET_DETAILS: "/get-school-details",
  UPDATE: "/update",
  REGISTER: "/register",
};

export const SCHOOL_API_REQUEST_FIELDS = {
  UDISE_CODE: "udise_code",
  SCHOOL_NAME: "school_name",
  SCHOOL_CODE: "school_code",
  SCHOOL_ID: "school_id",
  PAGE: "page",
  PAGE_SIZE: "page_size",
};

export const SCHOOL_API_PAYLOAD_FIELDS = {
  SCHOOL_NAME: "school_name",
  SCHOOL_TYPE: "school_type",
  UDISE_CODE: "udise_code",
  ADDRESS: "address",
  COUNTRY_ID: "country_id",
  CITY_ID: "city_id",
  STATE_ID: "state_id",
  DISTRICT_NAME: "district_name",
  AREA: "area",
  POSTAL_CODE: "postal_code",
  FEE: "fee",
  TIER_ID: "tier_id",
  TOTAL_STUDENT_COUNT: "total_student_count",
  TOTAL_TEACHER_COUNT: "total_teacher_count",
  POC_ID: "poc_id",
  EXECUTIVE_ID: "executive_id",
  GRADE_WISE_STUDENT_COUNT: "grade_wise_student_count",
  GRADE_ID: "grade_id",
  STUDENT_COUNT: "student_count",
  STATUS: "status",
};

export const SCHOOL_API_RESPONSE_FIELDS = {
  SCHOOL_ID: "schoolId",
  SCHOOLS: "schools",
  TOTAL_COUNT: "totalCount",
  TOTAL_PAGES: "totalPages",
  PAGE: "page",
  PAGE_SIZE: "pageSize",
};

export const SCHOOL_QUERY_KEYS = {
  DETAILS: "schoolDetails",
  CATEGORY_DETAILS: "schoolCategoryDetails",
  GRADE_LIST: "gradeList",
  BOARD_LIST: "boardList",
  COUNTRY_LIST: "countryList",
  CITY_LIST: "cityList",
  TIER_LIST: "tierList",
  POSTAL_CODE_DETAILS: "postalCodeDetails",
  SEARCH_POC_AGENTS: "searchPocAgents",
  SEARCH_EXECUTIVE_AGENTS: "searchExecutiveAgents",
  AGENTS_BY_USER_IDS: "agentsByUserIds",
  UDISE_SCHOOL: "udiseSchool",
};

export const UDISE_SCHOOL_API_REQUEST_FIELDS = {
  UDISE_CODE: "udise_code",
};

export const UDISE_CREATE_FORM_MAP = [
  { formKey: "schoolName", path: ["schoolName"], kind: "text" },
  {
    formKey: "totalStudentCount",
    path: ["enrollment", "totalStudents"],
    kind: "int",
  },
  {
    formKey: "totalTeacherCount",
    path: ["teachers", "totalTeachers"],
    kind: "int",
  },
  { formKey: "fee", path: ["finance", "annualSchoolFee"], kind: "int" },
  { formKey: "address", path: ["location", "streetAddress"], kind: "text" },
  { formKey: "postalCode", path: ["location", "pincode"], kind: "text" },
];

export const SCHOOL_FEE_CATEGORY_MISSING_WARNING =
  "Fee and category are not present.";

export const SCHOOL_MDS_RESOURCE_TYPES = {
  GRADE: "grade",
  BOARD: "board",
  COUNTRY: "country",
  CITY: "city",
  CITY_TIER: "city_tier",
};

export const SCHOOL_API_HEADER_VALUES = {
  ACCEPT_JSON: "application/json",
  PLATFORM_WEB: "web",
};